import React from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';

const RegistrationCTA = ({ onGetStarted }) => {
  const guarantees = [
    "Free Setup",
    "30-Day Money Back Guarantee",
    "24/7 Support"
  ];

  return (
    <section className="py-20 bg-gradient-to-r from-primary to-primary-dark text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Ready to Transform Your Screen Into Revenue?
        </h2>
        <p className="text-xl opacity-90 mb-8">
          Join thousands of successful screen owners and advertisers already earning with Sy9 Network
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <button 
            className="bg-white text-primary font-semibold px-8 py-4 rounded-lg hover:bg-gray-100 transition-all duration-250 text-lg"
            onClick={() => onGetStarted('screen-owner')}
          >
            Start Earning as Screen Owner
          </button>
          <button 
            className="border-2 border-white text-white font-semibold px-8 py-4 rounded-lg hover:bg-white hover:text-primary transition-all duration-250 text-lg"
            onClick={() => onGetStarted('advertiser')}
          >
            Launch Advertising Campaign
          </button>
        </div>
        
        <div className="flex flex-wrap justify-center items-center gap-8 text-sm opacity-80">
          {guarantees.map((guarantee, index) => (
            <div key={index} className="flex items-center">
              <CheckIcon className="w-5 h-5 mr-2" />
              {guarantee}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RegistrationCTA;